import React from "react";
import PayrollSalary from "../../../../entities/DashboardPage/HRModule/PayrollSalary";
// import { useNavigate, useParams } from "react-router-dom";
// import AuthService from "../../../api/AuthService";
// import LoaderHelper from "../../../utils/Loader/LoaderHelper";

const PayrollSalarySlip = () => {

  return (
    <>
      <PayrollSalary/>
    </>
  )

}

export default PayrollSalarySlip;
